import { useState, useRef, forwardRef, useEffect, useContext, useMemo } from 'react';
import { TextField } from '@mui/material';
import { MuiTelInput } from 'mui-tel-input';
import { IMaskInput, IMask } from 'react-imask';

const TextMaskCustom = forwardRef(function TextMaskCustom(props, ref) {
    const { onChange, ...other } = props;
    return (
      <IMaskInput
        {...other}
        mask="000 000 00 00 ######" // Маска с запасом
        definitions={{
          '#': /[0-9]/,
        }}
        inputRef={ref}
        onAccept={(value) => onChange({ target: { name: props.name, value } })}
        overwrite
      />
    );
  });

export const PhoneInputGroup = ({ countryCode, setCountryCode, number, setNumber }) => {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'row', 
      width: '70%', 
      marginTop: '10px',
      filter: 'drop-shadow(0px 2px 2px rgba(0,0,0,0.05))'
    }}>
      {/* ЛЕВАЯ ЧАСТЬ: Выбор кода страны */}
      <MuiTelInput
        value={countryCode}
        onChange={(val, info) => {
          if (info.countryCallingCode) {
            setCountryCode(`+${info.countryCallingCode}`);
          } else {
            setCountryCode(val);
          }
        }}
        defaultCountry="RU"
        langOfCountryName="ru"
        forceCallingCode
        variant="filled"
        disableFormatting
        inputProps={{ 
            readOnly: true, 
            style: { cursor: 'pointer', paddingLeft: '0px', textAlign: 'center' } 
        }}
        sx={{
          width: '100px',
          "& .MuiFilledInput-root": {
            backgroundColor: "#e0e0e0",
            borderRadius: '7px 0 0 7px',
            "&:hover": { backgroundColor: "#d5d5d5" },
            "&.Mui-focused": { backgroundColor: "#e0e0e0" }
          },
          '& .MuiTelInput-Flag': { display: 'none' },
          '& .MuiTelInput-IconButton': {
            '&::after': {
              content: '"◉"',
              fontSize: '18px',
              color: '#078376',
              marginLeft: '8px'
            }
          },
          "& .MuiFilledInput-underline:before": { borderBottom: "none" },
          "& .MuiFilledInput-underline:after": { borderBottom: "none" },
          "& .MuiInputBase-input": {
            fontWeight: '600',
            fontSize: '15px',
            paddingRight: '0px'
          }
        }}
      />

      {/* ПРАВАЯ ЧАСТЬ: Ввод номера */}
      <TextField
        variant="filled"
        placeholder="000-000-00-00"
        value={number}
        onChange={(e) => setNumber(e.target.value)}
        InputProps={{
          inputComponent: TextMaskCustom,
          disableUnderline: true,
        }}
        sx={{
          flexGrow: 1,
          marginLeft: '-1px',
          "& .MuiFilledInput-root": {
            backgroundColor: "#e0e0e0",
            borderRadius: '0 7px 7px 0',
            borderLeft: '1px solid rgba(0,0,0,0.1)',
            "&:hover": { backgroundColor: "#d5d5d5" },
            "&.Mui-focused": { backgroundColor: "#e0e0e0" }
          },
          "& .MuiFilledInput-underline:before": { borderBottom: "none" },
          "& .MuiFilledInput-underline:after": { borderBottom: "none" },
          "& .MuiInputBase-input": {
            fontWeight: '200',
            fontSize: '15px',
            paddingLeft: '15px'
          }
        }}
      />
    </div>
  );
};